module.exports = __webpack_public_path__ + "assets/img/heart-selected.b405cf08.png";